var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useState, useEffect, forwardRef, useImperativeHandle, } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import SingleHeadingText from "../../CommonTocComponent/TocHeader/SingleHeadingText";
import TocStockHeader from "../../CommonTocComponent/TocHeader/TocStockHeader";
import BuySellBtn from "../../CommonTocComponent/Stock/BuySellBtn";
import BankAccount from "./CommonPaymentMethod/BankAccount";
import NotificationMessage from "../../CommonTocComponent/StatusMessage/NotificationMessage";
import { SebiRulesBottom, SebiRulesTop } from "../NFOConstant";
import { Col, Row } from "react-bootstrap";
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import UnderstandingSectionIcon from "../../CommonTocComponent/UnderstandSection/UnderstandingSectionIcon";
import tocDi from "../../di/servicelocator";
import DiffrentBankAccount from "./BankAccount/DiffrentBankAccount";
import DiffrentUpiId from "./DiffUpiId/DiffrentUpiId";
import WhyUpi from "./CommonPaymentMethod/WhyUpi";
import { eCollectBankDetails } from "../../constant";
import { schemeErrors } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import Loader from "@frameworks/web/components/generic/loader";
export var EPaymentType;
(function (EPaymentType) {
    EPaymentType["NetBanking"] = "NetBanking";
    EPaymentType["UPI"] = "UPI";
    EPaymentType["ECollect"] = "eCollect";
})(EPaymentType || (EPaymentType = {}));
export var paymentMethodRadio = [
    { value: EPaymentType.NetBanking, display: "Net Banking" },
    { value: EPaymentType.UPI, display: "UPI" },
    // { value: EPaymentType.ECollect, display: "eCollect" },
];
export var EPaymentFlow;
(function (EPaymentFlow) {
    EPaymentFlow["UPI"] = "upi";
    // ADDUPI = "addUPI",
    EPaymentFlow["PAYMENT"] = "payment";
    EPaymentFlow["DIFBANK"] = "difBank";
    EPaymentFlow["DIFUPI"] = "difUPI";
    EPaymentFlow["UPIINFO"] = "upiInfo";
    EPaymentFlow["LOADER"] = "loader";
})(EPaymentFlow || (EPaymentFlow = {}));
var PaymentMethod = forwardRef(function (props, ref) {
    var device = DeviceContext();
    var _a = __read(useState(paymentMethodRadio[0].value), 2), paymentMethodData = _a[0], setpaymentMethodData = _a[1];
    var _b = __read(useState(EPaymentFlow.PAYMENT), 2), paymentFlow = _b[0], setPaymentFlow = _b[1];
    var _c = __read(useState(), 2), bankDetails = _c[0], setBankDetails = _c[1];
    var _d = __read(useState(), 2), selectedBank = _d[0], setSelectedBank = _d[1];
    var _e = __read(useState(), 2), bankList = _e[0], setBankList = _e[1];
    var _f = __read(useState(), 2), selectedUPI = _f[0], setSelectedUPI = _f[1];
    var _g = __read(useState(), 2), upiList = _g[0], setUPIList = _g[1];
    var _h = __read(useState(false), 2), readmore = _h[0], setReadmore = _h[1];
    var _j = __read(useState({ msg: "", status: false }), 2), bankErrors = _j[0], setBankErrors = _j[1];
    useEffect(function () {
        props.setSelectedBank(selectedBank);
    }, [selectedBank]);
    useEffect(function () {
        setPaymentFlow(EPaymentFlow.LOADER);
        tocDi.payment
            .getPayBankDetails()
            .then(function (data) {
            var _a;
            setBankDetails(data.details);
            if (data.details.bnkAcs.length > 0) {
                var bank = data.details.bnkAcs.length > 1
                    ? data.details.bnkAcs.find(function (x) { return x.latest; }) ||
                        data.details.bnkAcs[0]
                    : data.details.bnkAcs[0];
                setSelectedBank({
                    bnkAcNo: bank.bnkAccNo,
                    bnkNm: bank.bnkName,
                    brn: bank.bankTyp,
                    def: bank.latest,
                    ifscCode: bank.ifsc,
                    bankId: bank.bankid,
                    bankCd: bank.bnkCode,
                });
                setBankList((_a = data.details.bnkAcs) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                    return {
                        bnkAcNo: x.bnkAccNo,
                        bnkNm: x.bnkName,
                        brn: x.bankTyp,
                        def: x.latest,
                        ifscCode: x.ifsc,
                        bankId: x.bankid,
                        bankCd: x.bnkCode,
                    };
                }));
            }
            if (data.details.upis.length > 0) {
                var upilist = data.details.upis.map(function (x) {
                    var _a, _b, _c;
                    return __assign(__assign({}, x), { bankName: (_c = (_b = (_a = data.details) === null || _a === void 0 ? void 0 : _a.bnkAcs) === null || _b === void 0 ? void 0 : _b.find(function (z) { return z.bnkAccNo === x.bankaccountnumber; })) === null || _c === void 0 ? void 0 : _c.bnkName });
                });
                setUPIList(upilist);
                setSelectedUPI(upilist.find(function (x) { return x.isprimary; }));
            }
            setPaymentFlow(EPaymentFlow.PAYMENT);
        })
            .catch(function (error) {
            setPaymentFlow(EPaymentFlow.PAYMENT);
            setBankErrors({ status: true, msg: schemeErrors["bank"] });
        });
    }, []);
    useImperativeHandle(ref, function () { return ({
        getSelectedBank: function () { return selectedBank; },
        getSelectedUPI: function () { return selectedUPI; },
        getBankDetails: function () { return bankDetails; },
        getPaymentMethod: function () { return paymentMethodData; },
    }); });
    var PaymentFlowSetup = function () {
        switch (paymentFlow) {
            case EPaymentFlow.LOADER:
                return React.createElement(Loader, null);
            case EPaymentFlow.PAYMENT:
                return (React.createElement(React.Fragment, null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Payment" }) }))) : (""),
                    React.createElement("div", { className: "overflow-scroll-400 cust-scroll-bar pb-5 bg_white accountNumber paymentmethodSection" },
                        React.createElement(Col, { lg: 12, className: "outer-body-section" },
                            React.createElement(Col, { lg: 12, className: "mt-3" },
                                React.createElement("h2", { className: "DMSanBold_18_700 txt_blackOne1 " }, "Payment Method"),
                                React.createElement("h4", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Select your preferable payment method"),
                                React.createElement("div", { className: "radio-btn-section" },
                                    React.createElement("div", { className: "outer-payment-radio" }, paymentMethodRadio.map(function (item) {
                                        return ((item.value != EPaymentType.UPI ||
                                            (item.value === EPaymentType.UPI &&
                                                (upiList === null || upiList === void 0 ? void 0 : upiList.length) > 0)) && (React.createElement(RadioButton, { className: "common-radio-button paymentmethodradio", name: "paymentType", list: item, onChange: function () {
                                                setpaymentMethodData(item.value);
                                            }, selected: paymentMethodData })));
                                    })),
                                    (upiList === null || upiList === void 0 ? void 0 : upiList.length) > 0 && (React.createElement("div", { className: "radio-rs d-flex" },
                                        React.createElement("div", { className: "recommended-section DMSanM_10_500" }, "Recommended"),
                                        React.createElement("div", { onClick: function () { return setPaymentFlow(EPaymentFlow.UPIINFO); } },
                                            React.createElement(UnderstandingSectionIcon, null))))))),
                        paymentMethodData === EPaymentType.NetBanking && (React.createElement(React.Fragment, null,
                            React.createElement(Col, { lg: 12, className: "mt-1 outer-body-section " },
                                React.createElement("h4", { className: device && device.isDesktop
                                        ? "DMSanM_14_500 txt_primaryGrey mb-10 mgt-25"
                                        : "DMSansMedium_12_500 txt_primaryGrey mb-10 mgt-15" }, "Select Bank account to pay through Net banking"),
                                React.createElement(BankAccount, { sectionHeadleftTop: "Bank Account Number", sectionHeadleftBottom: selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkAcNo, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkNm }),
                                !!bankErrors.msg && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 pt-3 d-flex" },
                                    React.createElement("span", null,
                                        React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                                    React.createElement("span", null, bankErrors.msg)))),
                            (bankList === null || bankList === void 0 ? void 0 : bankList.length) > 1 && (React.createElement(Col, { lg: 12, className: "diffrentbankAccountlink text-center" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: "Choose different bank account", onClick: function () { return setPaymentFlow(EPaymentFlow.DIFBANK); } }))))),
                        paymentMethodData === EPaymentType.UPI && (React.createElement(React.Fragment, null,
                            React.createElement(Col, { lg: 12, className: "mt-1 outer-body-section " },
                                (upiList === null || upiList === void 0 ? void 0 : upiList.length) >= 1 && (React.createElement("h4", { className: "DMSanM_14_500 txt_primaryGrey mb-10" }, "Select UPI ID to pay through UPI app")),
                                selectedUPI && (React.createElement(BankAccount, { sectionHeadleftTop: "Bank Account Number", sectionHeadleftBottom: selectedUPI.bankaccountnumber, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: selectedUPI.bankName, sectionHeadleft2Top: "UPI ID", sectionHeadleft2Bottom: selectedUPI.upi })),
                                !!bankErrors.msg && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 pt-3 d-flex" },
                                    React.createElement("span", null,
                                        React.createElement("i", { className: "edel-icon-validation pe-1  align-middle" })),
                                    React.createElement("span", null, bankErrors.msg)))),
                            (upiList === null || upiList === void 0 ? void 0 : upiList.length) > 1 && (React.createElement(Col, { lg: 12, className: "diffrentbankAccountlink text-center" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: "Choose different UPI ID", onClick: function () { return setPaymentFlow(EPaymentFlow.DIFUPI); } }))))),
                        paymentMethodData === EPaymentType.ECollect && (React.createElement("div", { className: "order-confirmation outer-body-section" },
                            React.createElement(Row, null,
                                React.createElement(Col, { lg: 12, className: "mt-1" },
                                    React.createElement("h4", { className: "DMSanM_14_500 txt_primaryGrey mb-10 " }, "Add our bank account and transfer funds through NEFT or RTGS"))),
                            eCollectBankDetails.map(function (item) {
                                return (React.createElement(Row, { className: "orderbody-list m-0" },
                                    React.createElement(Col, { lg: 5, className: "px-0 pb-10 pt-10" },
                                        React.createElement("div", { className: "DMSansNormal_12_400 txt_blackOne1" }, item.key)),
                                    React.createElement(Col, { lg: 7, className: "px-0 pb-10 pt-10" },
                                        React.createElement("div", { className: "DMSans_16_500 txt_blackOne1 text-end" }, item.value))));
                            }))),
                        React.createElement(Col, { lg: 12, className: "notificationsection" },
                            React.createElement(NotificationMessage, { backColor: "#FEF4EC", borderColor: "transparent", notiiconAlert: true, notiHeading: "New Payment Rules by SEBI", DescriptionTop: SebiRulesTop, ShowlinkValue: true, linkValue: "Read more about NAV applicability and fund realization", DescriptionBottom: SebiRulesBottom, showDescriptionBottom: true })),
                        React.createElement(Col, { lg: 12, className: "notificationsection" },
                            React.createElement(NotificationMessage, { borderColor: "#E8E8E8", backColor: "#FFF", prefredIcon: true, notiHeading: "Preferred Banks", DescriptionTop: React.createElement(React.Fragment, null,
                                    React.createElement("span", null, "Exchange has direct integration with these banks"),
                                    readmore && (React.createElement("span", null,
                                        "leading to faster credit of fund into exchange bank accounts and thus a higher probability of receiving NAV of same date. Subject to fund cutoff timings for same day NAV applicability and actual fund realization time. ",
                                        React.createElement("br", null),
                                        "Axis Bank, ICICI Bank, SBI Bank, Kotak Mahindra Bank, Yes Bank, HDFC Bank, IDBI Bank")),
                                    !readmore && (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left small-edbutton ms-1", value: "Read More", onClick: function () { return setReadmore(true); } }))), parentclass: "noti-small-section", linkValue: "Read more about NAV applicability and fund realization", DescriptionBottom: SebiRulesBottom, ShowlinkValue: false, showDescriptionBottom: false }))),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                                btnTyp: "midnight-blue",
                                value: "Procced",
                                className: "w-100",
                                disabled: bankErrors.status === true ||
                                    (paymentMethodData === EPaymentType.UPI && !selectedUPI) ||
                                    (paymentMethodData === EPaymentType.NetBanking &&
                                        (!(selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkAcNo) ||
                                            !(selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.ifscCode) ||
                                            !(selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkNm)))
                                    ? true
                                    : false,
                                onClick: function () {
                                    if (!(selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bankCd)) {
                                        setBankErrors({
                                            status: true,
                                            msg: schemeErrors["payment"],
                                        });
                                        setTimeout(function () {
                                            setBankErrors({ status: false, msg: "" });
                                        }, 10000);
                                    }
                                    else {
                                        if (paymentMethodData === EPaymentType.UPI) {
                                            if ((upiList === null || upiList === void 0 ? void 0 : upiList.length) > 0) {
                                                props.onSubmit();
                                            }
                                        }
                                        else if (paymentMethodData === EPaymentType.NetBanking) {
                                            if ((selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkAcNo) &&
                                                (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.ifscCode) &&
                                                (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bnkNm))
                                                props.onSubmit();
                                        }
                                    }
                                },
                            }, cancelAction: function () { return props.back(); } }))));
            case EPaymentFlow.DIFBANK:
                return (React.createElement(DiffrentBankAccount, { setShow: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); }, back: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); }, next: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); }, bankList: bankList, setSelectedBank: setSelectedBank, selectedBank: selectedBank }));
            case EPaymentFlow.DIFUPI:
                return (React.createElement(DiffrentUpiId, { back: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); }, next: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); }, upiList: upiList, selectedUPI: selectedUPI, setSelectedUPI: setSelectedUPI }));
            case EPaymentFlow.UPIINFO:
                return React.createElement(WhyUpi, { back: function () { return setPaymentFlow(EPaymentFlow.PAYMENT); } });
        }
    };
    return React.createElement(React.Fragment, null, PaymentFlowSetup());
});
export default PaymentMethod;
